import service from "./index";

//会诊量统计（柱状图）
export const getConsultationVolumeAll = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ConsultationVolumeAll", ...data },
		RequestModel: null
	});
};
//会诊量统计（折线图）
export const getYearConsultation = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "YearConsultation", ...data },
		RequestModel: null
	});
};
//会诊量统计（折线图）
export const GetFirstGroupData = (HOSPITAL_CODE) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "GetFirstGroupData", HOSPITAL_CODE, },
		RequestModel: null
	});
};

//综合查询模块获取二级分组列表
export const getSearchPartSecondData = (Command, HOSPITAL_CODE, FIRST_GROUP_CODE) => {
	return service.post("/api/websiteecg", {
		// Command: "E00117",
		Command,
		Param: { Type: "GetSecondGroupData", HOSPITAL_CODE, FIRST_GROUP_CODE },
		RequestModel: null
	});
};
//数据统计申请医院列表会诊医院列表--加分组的
export const getHospitalListGroups = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};
//根据会诊医院获取申请医院--加分组的
export const getConsultationApplyHospitalGroup = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};
//会诊量统计表(不包含申请医院)
export const getConsultationTotal = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ConsultationTotalVariable", ...data },
		RequestModel: null
	});
};
//医生工作量统计
export const getDoctorWorkload = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "DoctorWorkload", ...data },
		RequestModel: null
	});
};
//综合查询模块根据分组、会诊医院获取会诊人
export const getSearchDoctorList = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};
//医生开单量统计
export const getBillDoctorWorkload = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "Billing_DoctorWorkload", ...data },
		RequestModel: null
	});
};
//医生工作量导出
export const getExportDoctorWorkload = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ExportDoctorWorkload", ...data },
		RequestModel: null
	});
};
//会诊量统计导出
export const getExportConsultationVolume = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ExportConsultationVolume", ...data },
		RequestModel: null
	});
};
//开单量统计导出
export const getExportBillDoctorWorkload = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ExportBilling_DoctorWorkload", ...data },
		RequestModel: null
	});
};
//根据会诊医院获取会诊人
export const getCustomData = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};
//自定义查询导出
export const getExportCustomData = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};


//会诊量统计（折线图）
export const GetApplyFirstGroupData = (HOSPITAL_CODE) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "GetApplyFirstGroupData", HOSPITAL_CODE, },
		RequestModel: null
	});
};

//会诊量统计（折线图）
export const GetApplySecondGroupData = (HOSPITAL_CODE,FIRST_GROUP_CODE) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "GetApplySecondGroupData", HOSPITAL_CODE,FIRST_GROUP_CODE },
		RequestModel: null
	});
};
//开单统计--医院列表
export const getBillingHospitalList = (Param) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param,
		RequestModel: null
	});
};
//会诊量统计表(选择申请医院的)
export const getApplyHospitalConsultation = (data) => {
	return service.post("/api/websiteecg", {
		Command: "E00144",
		Param: { Type: "ApplyHospital_ConsultationVariable", ...data },
		RequestModel: null
	});
};